<template>
    <div class="banner-box">
        <img :src="banner.img">

        <div class="banner-middle">
            <div class="banner-title">
                <span>{{banner.title[0]}}</span>
                <span>{{banner.title[1]}}</span>
            </div>

            <div
            v-if="banner.text"
            class="banner-takeaway">
                <p v-html="banner.text"></p>

                <el-link
                v-if="banner.more"
                :href="banner.more.url"
                target="_blank"
                :underline="false">{{banner.more.name}}</el-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: ['banner']
}
</script>

<style scoped>
.banner-box {
    position: relative;
    margin-top: 60px;
}

.banner-box img {
    width: 100%;
}

.banner-middle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 1000px;
    height: 300px;
    position: absolute;
    top: 40px;
    left: calc(50% - 600px);
}

.banner-title {
    flex: 0 0 100%;
}

.banner-title span {
    display: block;
    font-size: 30px;
    font-weight: bold;
    color: #111;
    margin-bottom: 10px;
}

.banner-takeaway {
    width: 500px;
    margin: auto;
    background: rgba(0, 0, 0, 0.5);
    position: relative;
    padding: 20px;
}

.banner-takeaway p {
    font-size: 12px;
    color: #fff;
    line-height: 30px;
}

.banner-takeaway .el-link {
    font-size: 12px;
    color: #eee;
    position: absolute;
    right: 10px;
    bottom: 10px;
}

@media(max-width: 1100px) {
    .banner-box {
        height: 350px;
        overflow: hidden;
        margin-top: 82px;
    }

    .banner-box img {
        width: auto;
        height: 100%;
        position: absolute;
        left: calc(50% - 640px);
    }

    .banner-middle {
        width: 90%;
        height: 80%;
        top: 10%;
        left: 5%;
    }

    .banner-title span {
        font-size: 20px;
        text-shadow: 5px 2px 6px #fff;
    }

    .banner-takeaway {
        background: rgba(0, 0, 0, .75);
    }

    .banner-takeaway p {
        line-height: 24px;
    }
}
</style>
